import React from "react";
import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";
import firebase from "../../lib/firebase";
import store from "../../lib/store";
import "./LoginDialog.css";

window.store = store;
export default class LoginDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = store.getState();
        this.unsubscribe = store.subscribe(() => {
            this.setState(store.getState());
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }


    handleOpen = () => {
        this.setState({open: true});
    };

    clickHandler = (providerType) => {
        let provider;
        switch(providerType){
            case 'google':
                provider = new firebase.auth.GoogleAuthProvider();
                break;
            case 'facebook':
                provider = new firebase.auth.FacebookAuthProvider();
                provider.addScope('email');
                break;
            default:
                throw new Error('로그인 방식이 올바르지 않습니다.');
        }
        firebase.auth().signInWithPopup(provider).then(function (result) {
            if(this.state.loginAfterExecute)
                this.state.loginAfterExecute();
            store.dispatch({type:'LOGIN_CLOSE'});
        }.bind(this)).catch(function (error) {
            if(error.code==="auth/account-exists-with-different-credential"){
                alert(`${error.email}은 다른 방법으로 인증을 이미 받았습니다. 이전에 인증 받은 방법으로 로그인을 시도해주세요.`);
            }
        });
    };

    render() {
        const authBtnStyle = {
            marginBottom:10
        }
        const dialogStyle={
            maxWidth:'350px'
        }
        return (
            <div className="AuthDialog">
                <Dialog
                    contentStyle={dialogStyle}
                    title="로그인 & 회원가입"
                    /*actions={(
                        <RaisedButton
                            label="닫기"
                            onTouchTap={function(){
                                this.props.onRequestClose()
                            }.bind(this)}
                        />
                    )}*/
                    modal={false}
                    open={this.state.loginOpen}
                    onRequestClose={this.props.onRequestClose}
                >
                    <div className="authTypes">
                        <RaisedButton
                            fullWidth={true}
                            style={authBtnStyle}
                            label="Google"
                            labelColor="white"
                            backgroundColor="#4285f4"
                            onTouchTap={this.clickHandler.bind(this, 'google')}
                        />
                        <RaisedButton
                            fullWidth={true}
                            style={authBtnStyle}
                            label="Facebook"
                            labelColor="white"
                            backgroundColor="#3b5998"
                            onTouchTap={this.clickHandler.bind(this, 'facebook')}
                        />
                    </div>
                </Dialog>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/Auth/LoginDialog.js